// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2rMUL","validationTips":"StatementDescriptor_validationTips__3tWB3"};